import '@mdi/font/css/materialdesignicons.css'
import { createVuetify, ThemeDefinition } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/styles' //Only component styles are included, global styles must be imported separately from 'vuetify/styles'.

const light: ThemeDefinition = {
  dark: false,
  colors: {
    // Base colors
    background: '#F9F9F9', // grayscale.almostWhite
    surface: '#FFFFFF', // general.white

    // Primary/CTA colors
    primary: '#009FE3', // general.cyan
    secondary: '#F8DEAE', // analyze.light
    'cyan-dark': '#004771', // general.darkBlue

    // Analyze brand colors
    'itemis-analyze-primary': '#F59E00', // analyze.medium
    'itemis-analyze-secondary': '#F8DEAE', // analyze.light
    'itemis-analyze-dark': '#CF7A2C', // analyze.dark

    // Grayscale
    'grey-darker': '#404040', // grayscale.dark (NEW)
    'grey-dark': '#808080', // grayscale.greyDark
    'grey-medium': '#CCCCCC', // grayscale.greyMedium
    'grey-light': '#F0F0F0', // grayscale.greyLight

    // Legacy/app-specific greys
    'itemis-analyze-grey': '#90a7b2',
    'itemis-hidden-grey': '#ADADAD',

    // Typography colors
    'font-color': '#001935', // App uses navy instead of token's #000000de
    'font-color-headline': '#00457C',

    // Status/warning colors
    error: '#FF0000', // warnings.red
    info: '#009FE3', // general.cyan
    success: '#58C863', // warnings.green
    warning: '#FFB930', // warnings.yellow
  },
}

if (light.colors) {
  light.colors['on-background'] = light.colors['font-color']
  light.colors['on-surface'] = light.colors['font-color']
  light.colors['on-primary'] = light.colors['surface']
  light.colors['on-secondary'] = light.colors['surface']
}

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light,
    },
  },
})
